import React from "react";
import "./Card.css";
import { clsx } from "../../utils/clsx";

export default function Card({ className, children, ...rest }) {
  return (
    <div className={clsx("ds-card", className)} {...rest}>{children}</div>
  );
}
